import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { LocalizationProvider } from './app/component/localization/LocalizationContext.js'; 
import { NetworkProvider } from './app/component/common/networkContext.js';

const rootElement = document.getElementById('root');

const renderApp = () => {
  createRoot(rootElement).render(
    <LocalizationProvider>
      <NetworkProvider>
        <Router>
          <App />
        </Router>
      </NetworkProvider>
    </LocalizationProvider>
  );
};

renderApp();
